import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type ChevronUpIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': ['M12 10L8 6L4 10'],
  '24': ['M18 15L12 9L6 15'],
  '32': ['M24 20L16 12L8 20'],
};

const ChevronUpIcon = (props: ChevronUpIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default ChevronUpIcon;
